import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTubeFolded = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "100%",
	height: "100%",
	viewBox: "0 0 1540 1498",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeMiterlimit: 1.5
	},
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "matrix(1,0,0,1,-1290.49,-1433.75)",
		children: /* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M1368.69,2621.47C1368.69,2621.47 2076.64,-49.492 2758.88,2823.76",
				style: {
					fill: "none",
					stroke: "black",
					strokeWidth: 100
				}
			}),
			/* @__PURE__ */ _jsx("g", {
				transform: "matrix(1,0,0,1,185,205)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M1404.36,2546.74C1404.36,2546.74 1507.87,2173.32 1614.3,1887.5C1794.66,1403.15 2039.32,1330.03 2338.81,2618.76L2573.88,2618.76",
					style: {
						fill: "none",
						stroke: "black",
						strokeWidth: 100
					}
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				transform: "matrix(0.636376,0.417814,-0.331319,0.504635,1647.31,723.865)",
				children: /* @__PURE__ */ _jsx("ellipse", {
					cx: 1234.85,
					cy: 2886.53,
					rx: 181.994,
					ry: 126.639,
					style: {
						fill: "white",
						stroke: "black",
						strokeWidth: "116.45px"
					}
				})
			})
		] })
	})
});
export default SvgTubeFolded;
